import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AuthenticationService } from '../services/auth.service';
import { AuthfakeauthenticationService } from '../services/authfake.service';

import { environment } from '../../../environments/environment';
import { TokenService } from 'src/app/services/token.service';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    token: any;
    expiration;
    constructor(
        private router: Router, 
        private tokensService: TokenService
      
    ) { }

            canActivate(
                next: ActivatedRouteSnapshot,
                state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
                      let tokenService1=new TokenService();   
                       this.token= tokenService1.getToken();  
                    
                    
                         this.expiration=tokenService1.getExpirationDate();   
                        if (this.token != null && this.token !=undefined && new Date(this.expiration)> new Date()) {   
                           return true;    }
                            this.router.navigate(['/account/login']);   
                         return false;





              /*   let tokenService1 = new TokenService();
                this.token = tokenService1.getToken();
                
                this.expiration = tokenService1.getExpirationDate();
            console.log( "expiration"+new Date(this.expiration) , new Date())
            console.log( "token" ,  this.token)

             var user = JSON.parse(localStorage.getItem('user'))


    if (user != null && this.token != null  && this.token != undefined  && new Date(this.expiration) > new Date()) {
        return this.checkUserLogin(next);
      }
        this.tokensService.clear();
        this.router.navigate(['/account/login'], { queryParams: { returnUrl: state.url } });
        return false; */
    }
    checkUserLogin(route: ActivatedRouteSnapshot): boolean {

        return true;
      }
}
